import axios from 'axios';
import config from '../config';

export const mergeRouteCardPdfs = (ids: string[]): Promise<string> => {
    return axios.post(`${config.API_URL}/route-cards/merge-pdfs`, { ids }).then((response: any) => {
        return response.data.data.presignedUrl;
    });
};
